import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserAccountReducer } from '../reducers';

export const selectUserAccountFeature = createFeatureSelector<UserAccountReducer.DataState>(UserAccountReducer.featureName);

export const selectFeatureUserAccount = createSelector(selectUserAccountFeature, (state: UserAccountReducer.DataState) => state.detail);
